export default {"src":"/_next/static/media/rounded_arrow.ac97c5f9.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};